import template from '@mailobj-browser/front/js/tree/template.js'
import manager from '@mailobj-browser/front/js/contracts/manager.js'

const { document } = globalThis

globalThis.mock = async html => {
  const { content } = template(document, {}, html)
  const { children: [...children] } = content
  
  await manager.fragment(...children)
  
  return children
}
